module.exports = __webpack_public_path__ + "static/media/vrbus2.a2db4cc2.jpg";